import {View} from 'MWC';
import tpl from '../templates/vacancy.jsx';
import {apiback} from '../../../config';
import PropTypes from 'prop-types';
import {VacancyModifierHelper} from '../helper/vacancy-modifier.helper';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
        this.state = {
            vacancy: {},
            showModal: false,
            id: props.match.params.id,
            preload: true
        };
        this.toggleModal = this.toggleModal.bind(this);
        return this;
    }

    componentDidMount() {
        this.getVacancy();
    }

    toggleModal() {
        if (this.state.id === '88') {
            window.dataLayer.push({
                event: 'button_click_vacancies'
            });
        }

        this.setState({showModal: !this.state.showModal});
    }

    getVacancy = () => {
        const url = apiback('API_VACANCIES', {});

        fetch(url + '/' + this.state.id)
            .then(res => res.json())
            .then(({data}) => {
                data = VacancyModifierHelper.generateTagsInCities(data);
                if (!data.length) {
                    this.context.app.navigate('/career/vacancies-list');
                } else {
                    this.setState({vacancy: data[0], preload: false});
                }
                window.scrollTo(0, 0);
            });
        // .catch(x => console.log('error:', x)); //todo добавить обработчик
    };

    static contextTypes = {
        app: PropTypes.object
    };
}
